import { cva } from 'class-variance-authority';

export const tabClasses = cva(
  [
    'text-sm',
    'py-2',
    'px-3',
    'cursor-pointer',
    'border-r',
    'border-info-300',
    'whitespace-nowrap',
    'overflow-hidden',
    'hover:bg-info-100',
    'select-none',
    'flex',
    'gap-2',
    'w-fit',
    'min-w-[10%]',
    'h-full',
    'items-center',
  ],
  {
    variants: {
      isTabOpen: {
        true: ['bg-info-50', 'shrink-0'],
        false: ['shrink'],
      },
      isSelected: {
        true: [],
        false: [],
      },
      isDefault: {
        true: ['max-w-[258px]'],
        false: ['max-w-[245px]'],
      },
    },
  },
);

export const checkMarkIconClasses = cva([], {
  variants: {
    isSelected: {
      true: ['text-primary-500'],
      false: ['text-info-400', 'hover:text-primary-500'],
    },
    isTabOpen: {
      true: ['visible'],
      false: ['hidden'],
    },
  },
});

export const autoSelectedIconClasses = cva(['text-info-400', 'cursor-help'], {
  variants: {
    tabAutoSelected: {
      false: '',
      true: 'text-primary-500',
    },
  },
});
